import { FontAwesomeIcons } from "src/constants/fontAwesomeIcons";
import { INavItem } from "src/components/layouts";

export function DashboardBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.HOME, title: "Dashboard", url: "/dashboard" },
    ];

    return breadcrumbs;
};

export function HomeBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.HOUSECHIMNEY, title: "Home", url: "/home" },
    ];

    return breadcrumbs;
};


export function SearchBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SEARCH, title: "Search", url: "/search" },
    ];

    return breadcrumbs;
};

export function CategoriesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Categories", url: "/settings/general/categories"}
    ];

    return breadcrumbs;
};

export function CategoryBreadcrumbs(categoryId: number, categoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Categories", url: "/settings/general/categories"},
        { icon: FontAwesomeIcons.Solid.TRIANGLE, title: categoryName ? categoryName : "Category", url: `/settings/general/categories/${categoryId}`}
    ];

    return breadcrumbs;
};

export function CategoryCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Categories", url: "/settings/general/categories"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/general/categories/create"}
    ];

    return breadcrumbs;
};

export function CountriesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.EARTHOCEANIA, title: "Countries", url: "/settings/general/countries"}
    ];

    return breadcrumbs;
};

export function CountryBreadcrumbs(countryId: number, countryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.EARTHOCEANIA, title: "Countries", url: "/settings/general/countries"},
        { icon: FontAwesomeIcons.Duotone.FLAG, title: countryName ? countryName : "Country", url: `/settings/general/countries/${countryId}`}
    ];

    return breadcrumbs;
};

export function CountryCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.EARTHOCEANIA, title: "Countries", url: "/settings/general/countries"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/general/countries/create"}
    ];

    return breadcrumbs;
};

export function RolesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.USERSHIELD, title: "Roles", url: "/settings/general/roles"}
    ];

    return breadcrumbs;
};

export function RoleBreadcrumbs(roleId: number, roleName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.USERSHIELD, title: "Roles", url: "/settings/general/roles"},
        { icon: FontAwesomeIcons.Duotone.SHIELDHALVED, title: roleName ? roleName : "Role", url: `/settings/general/roles/${roleId}`}
    ];

    return breadcrumbs;
};

export function RoleCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.USERSHIELD, title: "Roles", url: "/settings/general/roles"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/general/roles/create"}
    ];

    return breadcrumbs;
};

export function StatesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.ROUTEINTERSTATE, title: "States", url: "/settings/general/states"}
    ];

    return breadcrumbs;
};

export function StateBreadcrumbs(stateId: number, stateName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.ROUTEINTERSTATE, title: "States", url: "/settings/general/states"},
        { icon: FontAwesomeIcons.Duotone.ROUTEHIGHWAY, title: stateName ? stateName : "State", url: `/settings/general/states/${stateId}`}
    ];

    return breadcrumbs;
};

export function StateCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.ROUTEINTERSTATE, title: "States", url: "/settings/general/states"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/general/states/create"}
    ];

    return breadcrumbs;
};

export function ItemComponentTypesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.LISTTIMELINE, title: "Item Component Types", url: "/settings/general/itemcomponenttypes"}
    ];

    return breadcrumbs;
};

export function ItemComponentTypeBreadcrumbs(itemcomponenttypeId: number, itemcomponenttypeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.LISTTIMELINE, title: "Item Component Types", url: "/settings/general/itemcomponenttypes"},
        { icon: FontAwesomeIcons.Duotone.OCTAGON, title: itemcomponenttypeName ? itemcomponenttypeName : "Item Component Types", url: `/settings/general/itemcomponenttypes/${itemcomponenttypeId}`}
    ];

    return breadcrumbs;
};

export function ItemComponentTypeCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.LISTTIMELINE, title: "Item Component Types", url: "/settings/general/itemcomponenttypes"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/general/itemcomponenttypes/create"}
    ];

    return breadcrumbs;
};

export function NoteTypesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.LISTRADIO, title: "Note Types", url: "/settings/general/notetypes"}
    ];

    return breadcrumbs;
};

export function NoteTypeBreadcrumbs(noteId: number, noteName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.LISTRADIO, title: "Note Types", url: "/settings/general/notetypes"},
        { icon: FontAwesomeIcons.Duotone.NOTE, title: noteName ? noteName : "Note Type", url: `/settings/general/notetypes/${noteId}`}
    ];

    return breadcrumbs;
};

export function NoteTypeCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.LISTRADIO, title: "Note Types", url: "/settings/general/notetypes"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/general/notetypes/create"}
    ];

    return breadcrumbs;
};

export function SettingsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" }
    ];

    return breadcrumbs;
};

export function TrialSettingsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trial", url: "/settings/trial" }
    ];

    return breadcrumbs;
};

export function TrialInstitutionSettingsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALINSTITUTION, title: "Trial Institution", url: "/settings/trialinstitution" }
    ];

    return breadcrumbs;
};

export function TrialGroupSettingsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALGROUP, title: "Trial Group", url: "/settings/trialgroup" }
    ];

    return breadcrumbs;
};

export function ProjectSettingsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Project", url: "/settings/project" }
    ];

    return breadcrumbs;
};

export function GeneralSettingsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" }
    ];

    return breadcrumbs;
};

export function GroupSettingsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Group", url: "/settings/group" }
    ];

    return breadcrumbs;
};


export function InstitutionSettingsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution" }
    ];

    return breadcrumbs;
};

export function QaSettingsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa" }
    ];

    return breadcrumbs;
};

export function InterestsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.STOMACH, title: "Interests", url: "/settings/general/interests"}
    ];

    return breadcrumbs;
};

export function InterestBreadcrumbs(interestId: number, interestName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.STOMACH, title: "Interests", url: "/settings/general/interests"},
        { icon: FontAwesomeIcons.Duotone.KIDENEYS, title: interestName ? interestName : "Interest", url: `/settings/general/interests/${interestId}`}
    ];

    return breadcrumbs;
};

export function InterestCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.STOMACH, title: "Interests", url: "/settings/general/interests"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/general/interests/create"}
    ];

    return breadcrumbs;
};

export function MembershipTypesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.PEOPLEGROUP, title: "Membership Types", url: "/settings/general/membershiptypes"}
    ];

    return breadcrumbs;
};

export function MembershipTypeBreadcrumbs(membershiptypeId: number, membershiptypesName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.PEOPLEGROUP, title: "Membership Types", url: "/settings/general/membershiptypes"},
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: membershiptypesName ? membershiptypesName : "Membership Type", url: `/settings/general/membershiptypes/${membershiptypeId}`}
    ];

    return breadcrumbs;
};

export function MembershipTypeCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.PEOPLEGROUP, title: "Membership Types", url: "/settings/general/membershiptypes"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/general/membershiptypes/create"}
    ];

    return breadcrumbs;
};

export function ProfessionalDisciplinesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.USERDOCTOR, title: "Professional Disciplines", url: "/settings/general/professionaldisciplines"}
    ];

    return breadcrumbs;
};

export function ProfessionalDisciplineBreadcrumbs(professionaldisciplinesId: number, professionaldisciplinesName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.USERDOCTOR, title: "Professional Disciplines", url: "/settings/general/professionaldisciplines"},
        { icon: FontAwesomeIcons.Duotone.STETHOSCOPE, title: professionaldisciplinesName ? professionaldisciplinesName : "Professional Discipline", url: `/settings/general/professionaldisciplines/${professionaldisciplinesId}`}
    ];

    return breadcrumbs;
};

export function ProfessionalDisciplineCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.USERDOCTOR, title: "Professional Disciplines", url: "/settings/general/professionaldisciplines"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/general/professionaldisciplines/create"}
    ];

    return breadcrumbs;
};

export function SalutationsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.PERSONHALFDRESS, title: "Salutations", url: "/settings/general/salutations"}
    ];

    return breadcrumbs;
};

export function SalutationBreadcrumbs(salutationId: number, salutationName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.PERSONHALFDRESS, title: "Salutations", url: "/settings/general/salutations"},
        { icon: FontAwesomeIcons.Duotone.TAGS, title: salutationName ? salutationName : "Salutation", url: `/settings/general/salutations/${salutationId}`}
    ];

    return breadcrumbs;
};

export function SalutationCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.COG, title: "General", url: "/settings/general" },
        { icon: FontAwesomeIcons.Duotone.PERSONHALFDRESS, title: "Salutations", url: "/settings/general/salutations"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/general/salutations/create"},
    ];

    return breadcrumbs;
};

export function ProjectItemTemplatesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/settings/project/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: "/settings/project/itemtemplates"}
    ];

    return breadcrumbs;
};

export function ProjectItemTemplateBreadcrumbs(itemTemplateId: number, itemTemplateName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/settings/project/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: "/settings/project/itemtemplates"},
        { icon: FontAwesomeIcons.Duotone.FILE, title: itemTemplateName ? itemTemplateName : "Item Template", url: `/settings/project/itemtemplates/${itemTemplateId}`}
    ];

    return breadcrumbs;
};

export function ProjectItemTemplateCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/settings/project/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: "/settings/project/itemtemplates"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/project/itemtemplates/create"}
    ];

    return breadcrumbs;
};

export function ProjectItemComponentsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/settings/project/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/project/itemcomponents"}
    ];

    return breadcrumbs;
};

export function ProjectItemComponentBreadcrumbs(itemComponentId: number, itemComponentName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/settings/project/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/project/itemcomponents"},
        { icon: FontAwesomeIcons.Duotone.FILE, title: itemComponentName ? itemComponentName : "Item Component", url: `/settings/project/itemcomponents/${itemComponentId}`}
    ];

    return breadcrumbs;
};

export function ProjectItemComponentCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/settings/project/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/project/itemcomponents"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/project/itemcomponents/create"}
    ];

    return breadcrumbs;
};

export function ProjectItemCategoriesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/settings/project/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/project/itemcategories"}
    ];

    return breadcrumbs;
};

export function ProjectItemCategoryBreadcrumbs(itemCategoryId: number, itemCategoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/settings/project/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/project/itemcategories"},
        { icon: FontAwesomeIcons.Duotone.STARSHARP, title: itemCategoryName ? itemCategoryName : "Item Category", url: `/settings/project/itemcategories/${itemCategoryId}`}
    ];

    return breadcrumbs;
};

export function ProjectItemCategoryCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/settings/project/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/project/itemcategories"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/project/itemcategories/create"},
    ];

    return breadcrumbs;
};

export function ProjectItemImportBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/settings/project/" },
        { icon: FontAwesomeIcons.Duotone.FILEIMPORT, title: "Item Import", url: "/settings/project/projectitemimport"}
    ];

    return breadcrumbs;
};

export function TrialItemImportBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trial", url: "/settings/trial/" },
        { icon: FontAwesomeIcons.Duotone.FILEIMPORT, title: "Item Import", url: "/settings/trial/projectitemimport"}
    ];

    return breadcrumbs;
};

export function TrialItemTemplatesBreadcrumbs(trialId?: number): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trial", url: "/settings/trial/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: trialId ? `/settings/trial/itemtemplates/${trialId}` : "/settings/trial/itemtemplates"}
    ];

    return breadcrumbs;
};

export function TrialInstitutionItemTemplatesBreadcrumbs(trialId?: number): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALINSTITUTION, title: "Trial Institution", url: "/settings/trialinstitution/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: trialId ? `/settings/trialinstitution/itemtemplates/${trialId}` : "/settings/trialinstitution/itemtemplates"}
    ];

    return breadcrumbs;
};

export function TrialItemTemplateBreadcrumbs(itemTemplateId: number, trialId?: number, itemTemplateName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trial", url: "/settings/trial/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: trialId ? `/settings/trial/itemtemplates/${trialId}` : "/settings/trial/itemtemplates"},
        { icon: FontAwesomeIcons.Duotone.FILE, title: itemTemplateName ? itemTemplateName : "Item Template", url: trialId ? `/settings/trial/itemtemplates/${trialId}/template/${itemTemplateId}` : `/settings/trial/itemtemplates/template/${itemTemplateId}`}
    ];

    return breadcrumbs;
};

export function TrialInstitutionItemTemplateBreadcrumbs(itemTemplateId: number, trialId?: number, itemTemplateName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALINSTITUTION, title: "Trial Institution", url: "/settings/trialinstitution/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: trialId ? `/settings/trialinstitution/itemtemplates/${trialId}` : "/settings/trialinstitution/itemtemplates"},
        { icon: FontAwesomeIcons.Duotone.FILE, title: itemTemplateName ? itemTemplateName : "Item Template", url: trialId ? `/settings/trialinstitution/itemtemplates/${trialId}/template/${itemTemplateId}` : `/settings/trialinstitution/itemtemplates/template/${itemTemplateId}`}
    ];

    return breadcrumbs;
};

export function TrialItemTemplateCreateBreadcrumbs(trialId?: number): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trial", url: "/settings/trial/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: trialId ? `/settings/trial/itemtemplates/${trialId}` : "/settings/trial/itemtemplates"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: trialId ? `/settings/trial/itemtemplates/${trialId}/template/create` : "/settings/trial/itemtemplates/template/create"}
    ];

    return breadcrumbs;
};

export function TrialInstitutionItemTemplateCreateBreadcrumbs(trialId?: number): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALINSTITUTION, title: "Trial Institution", url: "/settings/trialinstitution/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: trialId ? `/settings/trialinstitution/itemtemplates/${trialId}` : "/settings/trialinstitution/itemtemplates"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: trialId ? `/settings/trialinstitution/itemtemplates/${trialId}/template/create` : "/settings/trialinstitution/itemtemplates/template/create"}
    ];

    return breadcrumbs;
};

export function TrialItemComponentsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trial", url: "/settings/trial/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/trial/itemcomponents"}
    ];

    return breadcrumbs;
};

export function TrialInstitutionItemComponentsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALINSTITUTION, title: "Trial Institution", url: "/settings/trialinstitution/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/trialinstitution/itemcomponents"}
    ];

    return breadcrumbs;
};

export function TrialGroupItemTemplatesBreadcrumbs(groupId?: number): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALGROUP, title: "Trial Group", url: "/settings/trialgroup/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: groupId ? `/settings/trialgroup/itemtemplates/${groupId}` : "/settings/trialgroup/itemtemplates"}
    ];

    return breadcrumbs;
};

export function TrialGroupItemTemplateBreadcrumbs(itemTemplateId: number, groupId?: number, itemTemplateName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALGROUP, title: "Trial Group", url: "/settings/trialgroup/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: groupId ? `/settings/trialgroup/itemtemplates/${groupId}` : "/settings/trialgroup/itemtemplates"},
        { icon: FontAwesomeIcons.Duotone.FILE, title: itemTemplateName ? itemTemplateName : "Item Template", url: groupId ? `/settings/trialgroup/itemtemplates/${groupId}/template/${itemTemplateId}` : `/settings/trialgroup/itemtemplates/template/${itemTemplateId}`}
    ];

    return breadcrumbs;
};

export function TrialGroupItemTemplateCreateBreadcrumbs(groupId?: number): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALGROUP, title: "Trial Group", url: "/settings/trialgroup/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: groupId ? `/settings/trialgroup/itemtemplates/${groupId}` : "/settings/trialgroup/itemtemplates"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: groupId ? `/settings/trialgroup/itemtemplates/${groupId}/template/create` : "/settings/trialgroup/itemtemplates/template/create"}
    ];

    return breadcrumbs;
};

export function TrialGroupItemTemplateCategoriesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALGROUP, title: "Trial Group", url: "/settings/trialgroup/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/trialgroup/itemtemplatecategories"}
    ];

    return breadcrumbs;
};

export function TrialGroupItemTemplateCategoryBreadcrumbs(categoryId: number, categoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALGROUP, title: "Trial Group", url: "/settings/trialgroup/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/trialgroup/itemtemplatecategories"},
        { icon: FontAwesomeIcons.Duotone.STARSHARP, title: categoryName ? categoryName : "Item Category", url: `/settings/trialgroup/itemtemplatecategories/${categoryId}`}
    ];

    return breadcrumbs;
};

export function TrialGroupItemTemplateCategoryCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALGROUP, title: "Trial Group", url: "/settings/trialgroup/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/trialgroup/itemtemplatecategories"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/trialgroup/itemtemplatecategories/create"}
    ];

    return breadcrumbs;
};

export function TrialGroupItemComponentsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALGROUP, title: "Trial Group", url: "/settings/trialgroup/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/trialgroup/itemcomponents"}
    ];

    return breadcrumbs;
};

export function TrialItemComponentBreadcrumbs(itemComponentId: number, itemComponentName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trial", url: "/settings/trial/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/trial/itemcomponents"},
        { icon: FontAwesomeIcons.Duotone.FILE, title: itemComponentName ? itemComponentName : "Item Component", url: `/settings/trial/itemcomponents/${itemComponentId}`}
    ];

    return breadcrumbs;
};

export function TrialInstitutionItemComponentBreadcrumbs(itemComponentId: number, itemComponentName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALINSTITUTION, title: "Trial Institution", url: "/settings/trialinstitution/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/trialinstitution/itemcomponents"},
        { icon: FontAwesomeIcons.Duotone.FILE, title: itemComponentName ? itemComponentName : "Item Component", url: `/settings/trialinstitution/itemcomponents/${itemComponentId}`}
    ];

    return breadcrumbs;
};

export function TrialGroupItemComponentBreadcrumbs(itemComponentId: number, itemComponentName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALGROUP, title: "Trial Group", url: "/settings/trialgroup/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/trialgroup/itemcomponents"},
        { icon: FontAwesomeIcons.Duotone.FILE, title: itemComponentName ? itemComponentName : "Item Component", url: `/settings/trialgroup/itemcomponents/${itemComponentId}`}
    ];

    return breadcrumbs;
};

export function TrialItemComponentCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trial", url: "/settings/trial/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/trial/itemcomponents"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/trial/itemcomponents/create"}
    ];

    return breadcrumbs;
};

export function TrialInstitutionItemComponentCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALINSTITUTION, title: "Trial Institution", url: "/settings/trialinstitution/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/trialinstitution/itemcomponents"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/trialinstitution/itemcomponents/create"}
    ];

    return breadcrumbs;
};

export function TrialGroupItemComponentCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALGROUP, title: "Trial Group", url: "/settings/trialgroup/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/trialgroup/itemcomponents"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/trialgroup/itemcomponents/create"}
    ];

    return breadcrumbs;
};

export function TrialItemTemplateCategoriesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trial", url: "/settings/trial/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/trial/itemtemplatecategories"}
    ];

    return breadcrumbs;
};

export function TrialInstitutionItemTemplateCategoriesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALINSTITUTION, title: "Trial Institution", url: "/settings/trialinstitution/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/trialinstitution/itemtemplatecategories"}
    ];

    return breadcrumbs;
};

export function TrialItemTemplateCategoryBreadcrumbs(categoryId: number, categoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trial", url: "/settings/trial/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/trial/itemtemplatecategories"},
        { icon: FontAwesomeIcons.Duotone.STARSHARP, title: categoryName ? categoryName : "Item Category", url: `/settings/trial/itemtemplatecategories/${categoryId}`}
    ];

    return breadcrumbs;
};

export function TrialInstitutionItemTemplateCategoryBreadcrumbs(categoryId: number, categoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALINSTITUTION, title: "Trial Institution", url: "/settings/trialinstitution/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/trialinstitution/itemtemplatecategories"},
        { icon: FontAwesomeIcons.Duotone.STARSHARP, title: categoryName ? categoryName : "Item Category", url: `/settings/trialinstitution/itemtemplatecategories/${categoryId}`}
    ];

    return breadcrumbs;
};

export function TrialItemTemplateCategoryCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trial", url: "/settings/trial/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/trial/itemtemplatecategories"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/trial/itemtemplatecategories/create"}
    ];

    return breadcrumbs;
};

export function TrialInstitutionItemTemplateCategoryCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIALINSTITUTION, title: "Trial Institution", url: "/settings/trialinstitution/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/trialinstitution/itemtemplatecategories"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/trialinstitution/itemtemplatecategories/create"}
    ];

    return breadcrumbs;
};

export function TrialTypesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trial", url: "/settings/trial/" },
        { icon: FontAwesomeIcons.Duotone.ATOMSIMPLE, title: "Trail Types", url: "/settings/trial/trialtypes"}
    ];

    return breadcrumbs;
};

export function TrialTypeBreadcrumbs(trialTypeId: number, trialTypeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trial", url: "/settings/trial/" },
        { icon: FontAwesomeIcons.Duotone.ATOMSIMPLE, title: "Trial Types", url: "/settings/trial/trialtypes"},
        { icon: FontAwesomeIcons.Duotone.POTATO, title: trialTypeName ? trialTypeName : "Trial Type", url: `/settings/trial/trialtypes/${trialTypeId}`}
    ];

    return breadcrumbs;
};

export function TrialTypeCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trial", url: "/settings/trial/" },
        { icon: FontAwesomeIcons.Duotone.ATOMSIMPLE, title: "Trial Types", url: "/settings/trial/trialtypes"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/trial/trialtypes/create"},
    ];

    return breadcrumbs;
};

export function GroupItemTemplatesBreadcrumbs(groupId?: number): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Group", url: "/settings/group/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: groupId ? `/settings/group/itemtemplates/${groupId}` : "/settings/group/itemtemplates"}
    ];

    return breadcrumbs;
};

export function GroupItemTemplateBreadcrumbs(itemTemplateId: number, groupId?: number, itemTemplateName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Group", url: "/settings/group/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: groupId ? `/settings/group/itemtemplates/${groupId}` : "/settings/group/itemtemplates"},
        { icon: FontAwesomeIcons.Duotone.FILE, title: itemTemplateName ? itemTemplateName : "Item Template", url: groupId ? `/settings/group/itemtemplates/${groupId}/template/${itemTemplateId}` : `/settings/group/itemtemplates/template/${itemTemplateId}`}
    ];

    return breadcrumbs;
};

export function GroupItemTemplateCreateBreadcrumbs(groupId?: number): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Group", url: "/settings/group/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: groupId ? `/settings/group/itemtemplates/${groupId}` : "/settings/group/itemtemplates"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: groupId ? `/settings/group/itemtemplates/${groupId}/template/create` : "/settings/group/itemtemplates/template/create"}
    ];

    return breadcrumbs;
};

export function GroupItemComponentsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Group", url: "/settings/group/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/group/itemcomponents"}
    ];

    return breadcrumbs;
};

export function GroupItemComponentBreadcrumbs(itemComponentId: number, itemComponentName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Group", url: "/settings/group/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/group/itemcomponents"},
        { icon: FontAwesomeIcons.Duotone.FILE, title: itemComponentName ? itemComponentName : "Item Component", url: `/settings/group/itemcomponents/${itemComponentId}`}
    ];

    return breadcrumbs;
};

export function GroupItemComponentCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Group", url: "/settings/group/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/group/itemcomponents"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/group/itemcomponents/create"}
    ];

    return breadcrumbs;
};

export function GroupItemCategoriesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Group", url: "/settings/group/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/group/itemcategories"}
    ];

    return breadcrumbs;
};

export function GroupItemCategoryBreadcrumbs(itemCategoryId: number, itemCategoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Group", url: "/settings/group/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/group/itemcategories"},
        { icon: FontAwesomeIcons.Duotone.STARSHARP, title: itemCategoryName ? itemCategoryName : "Item Category", url: `/settings/group/itemcategories/${itemCategoryId}`}
    ];

    return breadcrumbs;
};

export function GroupItemCategoryCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Group", url: "/settings/group/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/group/itemcategories"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/group/itemcategories/create"},
    ];

    return breadcrumbs;
};

export function GroupNoteBreadcrumbs(groupId: number, noteId: number): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Group", url: "/settings/group/" },
        { icon: FontAwesomeIcons.Duotone.NOTE, title: "Note", url: `/settings/group/${groupId}/notes/${noteId}`}
    ];

    return breadcrumbs;
};

export function SiteLocationsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGFLAG, title: "Site Locations", url: "/settings/institution/sitelocations"}
    ];

    return breadcrumbs;
};

export function SiteLocationBreadcrumbs(siteLocationId: number, siteLocationName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGFLAG, title: "Site Locations", url: "/settings/institution/sitelocations"},
        { icon: FontAwesomeIcons.Duotone.FLAGCHECKERED, title: siteLocationName ? siteLocationName : "Site Location", url: `/settings/institution/sitelocations/${siteLocationId}`}
    ];

    return breadcrumbs;
};

export function SiteLocationCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGFLAG, title: "Site Locations", url: "/settings/institution/sitelocations"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/institution/sitelocations/create"}
    ];

    return breadcrumbs;
};

export function KeyContactsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.ADDRESSBOOK, title: "Key Contacts", url: "/settings/institution/keycontacts"}
    ];

    return breadcrumbs;
};

export function KeyContactBreadcrumbs(keyContactId: number, keyContactName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGFLAG, title: "Key Contacts", url: "/settings/institution/keycontacts"},
        { icon: FontAwesomeIcons.Duotone.SIMCARDS, title: keyContactName ? keyContactName : "Key Contact", url: `/settings/institution/keycontacts/${keyContactId}`}
    ];

    return breadcrumbs;
};

export function KeyContactCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGFLAG, title: "Key Contacts", url: "/settings/institution/keycontacts"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/institution/keycontacts/create"}
    ];

    return breadcrumbs;
};

export function FacilityAllianceMembersBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.KAZOO, title: "Facility Alliance Members", url: "/settings/institution/facilityalliancemembers"}
    ];

    return breadcrumbs;
};

export function FacilityAllianceMemberBreadcrumbs(facilityAllianceMemberId: number, facilityAllianceMemberName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.KAZOO, title: "Facility Alliance Members", url: "/settings/institution/facilityalliancemembers"},
        { icon: FontAwesomeIcons.Duotone.SIMCARDS, title: facilityAllianceMemberName ? facilityAllianceMemberName : "Facility Alliance Member", url: `/settings/institution/facilityalliancemembers/${facilityAllianceMemberId}`}
    ];

    return breadcrumbs;
};

export function FacilityAllianceMemberCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.KAZOO, title: "Facility Alliance Members", url: "/settings/institution/facilityalliancemembers"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/institution/facilityalliancemembers/create"},
    ];

    return breadcrumbs;
};

export function InstitutionTypesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.HOUSEMEDICAL, title: "Institution Types", url: "/settings/institution/institutiontypes"}
    ];

    return breadcrumbs;
};

export function InstitutionTypeBreadcrumbs(institutionTypeId: number, institutionTypeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.HOUSEMEDICAL, title: "Institution Types", url: "/settings/institution/institutiontypes"},
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: institutionTypeName ? institutionTypeName : "Institution Type", url: `/settings/institution/institutiontypes/${institutionTypeId}`}
    ];

    return breadcrumbs;
};

export function InstitutionTypeCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.HOUSEMEDICAL, title: "Institution Types", url: "/settings/institution/institutiontypes"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/institution/institutiontypes/create"}
    ];

    return breadcrumbs;
};

export function InstitutionItemComponentsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/institution/itemcomponents"}
    ];

    return breadcrumbs;
};

export function InstitutionItemComponentCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/institution/itemcomponents"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/institution/itemcomponents/create"}
    ];

    return breadcrumbs;
};

export function InstitutionItemComponentBreadcrumbs(itemComponentId: number, itemComponentName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Item Components", url: "/settings/institution/itemcomponents"},
        { icon: FontAwesomeIcons.Duotone.FILE, title: itemComponentName ? itemComponentName : "Item Component", url: `/settings/institution/itemcomponents/${itemComponentId}`}
    ];

    return breadcrumbs;
};

export function InstitutionItemTemplatesBreadcrumbs(institutionId?: number): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: institutionId ? `/settings/institution/itemtemplates/${institutionId}` : "/settings/institution/itemtemplates"}
    ];

    return breadcrumbs;
};

export function InstitutionItemTemplateBreadcrumbs(itemTemplateId: number, institutionId?: number, itemTemplateName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: institutionId ? `/settings/institution/itemtemplates/${institutionId}` : "/settings/institution/itemtemplates"},
        { icon: FontAwesomeIcons.Duotone.FILE, title: itemTemplateName ? itemTemplateName : "Item Template", url: institutionId ? `/settings/institution/itemtemplates/${institutionId}/template/${itemTemplateId}` : `/settings/institution/itemtemplates/template/${itemTemplateId}`}
    ];

    return breadcrumbs;
};

export function InstitutionItemTemplateCreateBreadcrumbs(trialId?: number): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Item Templates", url: trialId ? `/settings/institution/itemtemplates/${trialId}` : "/settings/institution/itemtemplates"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: trialId ? `/settings/institution/itemtemplates/${trialId}/template/create` : "/settings/institution/itemtemplates/template/create"}
    ];

    return breadcrumbs;
};

export function InstitutionItemTemplateCategoriesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/institution/itemtemplatecategories"}
    ];

    return breadcrumbs;
};

export function InstitutionItemTemplateCategoryBreadcrumbs(categoryId: number, categoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/institution/itemtemplatecategories"},
        { icon: FontAwesomeIcons.Duotone.STARSHARP, title: categoryName ? categoryName : "Item Category", url: `/settings/trial/itemtemplatecategories/${categoryId}`}
    ];

    return breadcrumbs;
};

export function InstitutionItemTemplateCategoryCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Item Categories", url: "/settings/institution/itemtemplatecategories"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/institution/itemtemplatecategories/create"},
    ];

    return breadcrumbs;
};

export function InstitutionCodingsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.CODE, title: "Institution Codings", url: "/settings/institution/institutioncodings"}
    ];

    return breadcrumbs;
};

export function InstitutionCodingBreadcrumbs(institutionCodeId: number, institutionCodeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.CODE, title: "Institution Codings", url: "/settings/institution/institutioncodings"},
        { icon: FontAwesomeIcons.Duotone.BLANKET, title: institutionCodeName ? institutionCodeName : "Institution Code", url: `/settings/institution/institutioncodings/${institutionCodeId}`}
    ];

    return breadcrumbs;
};

export function InstitutionCodingCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institution", url: "/settings/institution/" },
        { icon: FontAwesomeIcons.Duotone.CODE, title: "Institution Codings", url: "/settings/institution/institutioncodings"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/institution/institutioncodings/create"}
    ];

    return breadcrumbs;
};

export function FormTemplatesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Form Templates", url: "/settings/qa/formtemplates"}
    ];

    return breadcrumbs;
};

export function FormTemplateBreadcrumbs(formTemplateId: number, FormTemplateName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Form Templates", url: "/settings/qa/formtemplates"},
        { icon: FontAwesomeIcons.Duotone.FILE, title: FormTemplateName ? FormTemplateName : "Form Template", url: `/settings/qa/formtemplates/${formTemplateId}`}
    ];

    return breadcrumbs;
};

export function FormTemplateCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.FOLDERS, title: "Form Templates", url: "/settings/qa/formtemplates"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/qa/formtemplates/create"},
    ];

    return breadcrumbs;
};

export function FormComponentsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Form Components", url: "/settings/qa/formcomponents"}
    ];

    return breadcrumbs;
};

export function FormComponentBreadcrumbs(formComponentId: number, FormComponentName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Form Components", url: "/settings/qa/formcomponents"},
        { icon: FontAwesomeIcons.Duotone.FILE, title: FormComponentName ? FormComponentName : "Form Component", url: `/settings/qa/formcomponents/${formComponentId}`}
    ];

    return breadcrumbs;
};

export function FormComponentCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.SOLARSYSTEM, title: "Form Components", url: "/settings/qa/formcomponents"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/qa/formcomponents/create"}
    ];

    return breadcrumbs;
};

export function ReportingTagsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.TAGS, title: "Reporting Tags", url: "/settings/qa/reportingtags"}
    ];

    return breadcrumbs;
};

export function ReportingTagBreadcrumbs(reportingTagId: number, reportingTagName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.TAGS, title: "Reporting Tags", url: "/settings/qa/reportingtags"},
        { icon: FontAwesomeIcons.Duotone.TAG, title: reportingTagName ? reportingTagName : "Reporting Tag", url: `/settings/qa/reportingtags/${reportingTagId}`}
    ];

    return breadcrumbs;
};

export function ReportingTagCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.TAGS, title: "Reporting Tags", url: "/settings/qa/reportingtags"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/qa/reportingtags/create"},
    ];

    return breadcrumbs;
};

export function ReportingTagCategoriesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Reporting Tag Categories", url: "/settings/qa/reportingtagcategories"}
    ];

    return breadcrumbs;
};

export function ReportingTagCategoryBreadcrumbs(reportingTagCategoryId: number, reportingTagCategoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Reporting Tag Categories", url: "/settings/qa/reportingtagcategories"},
        { icon: FontAwesomeIcons.Duotone.STARSHARP, title: reportingTagCategoryName ? reportingTagCategoryName : "Reporting Category", url: `/settings/qa/reportingtagcategories/${reportingTagCategoryId}`}
    ];

    return breadcrumbs;
};

export function ReportingTagCategoryCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.SHAPES, title: "Reporting Tag Categories", url: "/settings/qa/reportingtagcategories"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/qa/reportingtagcategories/create"}
    ];

    return breadcrumbs;
};

export function TaskTypesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.BARSPROGRESS, title: "Task Types", url: "/settings/qa/tasktypes"}
    ];

    return breadcrumbs;
};

export function TaskTypeBreadcrumbs(taskTypeId: number, taskTypeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.BARSPROGRESS, title: "Task Types", url: "/settings/qa/tasktypes"},
        { icon: FontAwesomeIcons.Duotone.CANDYBAR, title: taskTypeName ? taskTypeName : "Task Type", url: `/settings/qa/tasktypes/${taskTypeId}`}
    ];

    return breadcrumbs;
};

export function TaskTypeCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.BARSPROGRESS, title: "Task Types", url: "/settings/qa/tasktypes"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/qa/tasktypes/create"},
    ];

    return breadcrumbs;
};

export function TrackerTypesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.WAVESSINE, title: "Tracker Types", url: "/settings/qa/trackertypes"}
    ];

    return breadcrumbs;
};

export function TrackerTypeBreadcrumbs(trackerTypeId: number, trackerTypeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.WAVESSINE, title: "Tracker Types", url: "/settings/qa/trackertypes"},
        { icon: FontAwesomeIcons.Duotone.WAVESINE, title: trackerTypeName ? trackerTypeName : "Tracker Type", url: `/settings/qa/trackertypes/${trackerTypeId}`}
    ];

    return breadcrumbs;
};

export function TrackerTypeCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.WAVESSINE, title: "Tracker Types", url: "/settings/qa/trackertypes"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/qa/trackertypes/create"}
    ];

    return breadcrumbs;
};

export function TrackerMilestonesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.TROPHY, title: "Tracker Milestones", url: "/settings/qa/trackermilestones"}
    ];

    return breadcrumbs;
};

export function TrackerMilestoneBreadcrumbs(trackerMilestoneId: number, trackerMilestoneName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.TROPHY, title: "Tracker Milestones", url: "/settings/qa/trackermilestones"},
        { icon: FontAwesomeIcons.Duotone.AWARD, title: trackerMilestoneName ? trackerMilestoneName : "Tracker Milestone", url: `/settings/qa/trackermilestones/${trackerMilestoneId}`}
    ];

    return breadcrumbs;
};

export function TrackerMilestoneCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.TROPHY, title: "Tracker Milestones", url: "/settings/qa/trackermilestones"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/qa/trackermilestones/create"}
    ];

    return breadcrumbs;
};

export function FileTypesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.FILES, title: "File Types", url: "/settings/qa/formtemplatefiletypes"}
    ];

    return breadcrumbs;
};

export function FileTypeBreadcrumbs(fileTypeId: number, fileTypeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.FILES, title: "File Types", url: "/settings/qa/formtemplatefiletypes"},
        { icon: FontAwesomeIcons.Duotone.FILE, title: fileTypeName ? fileTypeName : "File Type", url: `/settings/qa/formtemplatefiletypes/${fileTypeId}`}
    ];

    return breadcrumbs;
};

export function FileTypeCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.FILES, title: "File Types", url: "/settings/qa/formtemplatefiletypes"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/qa/formtemplatefiletypes/create"}
    ];

    return breadcrumbs;
};

export function EmailTemplatesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.INBOXES, title: "Email Templates", url: "/settings/qa/qaemailtemplates"}
    ];

    return breadcrumbs;
};

export function EmailTemplateBreadcrumbs(emailTemplateId: number, emailTemplateName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.INBOXES, title: "Email Templates", url: "/settings/qa/qaemailtemplates"},
        { icon: FontAwesomeIcons.Duotone.INBOXFULL, title: emailTemplateName ? emailTemplateName : "Email Template", url: `/settings/qa/qaemailtemplates/${emailTemplateId}`}
    ];

    return breadcrumbs;
};

export function EmailTemplateCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.QA, title: "QA", url: "/settings/qa/" },
        { icon: FontAwesomeIcons.Duotone.INBOXES, title: "Email Templates", url: "/settings/qa/qaemailtemplates"},
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/qa/qaemailtemplates/create"},
    ];

    return breadcrumbs;
};

export function OpenClinicaUserRolesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.OPENCLINICA, title: "OpenClinica User Roles", url: "/settings/openclinicauserroles" }
    ];

    return breadcrumbs;
};

export function HrecsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.HANDHOLDINGHEART, title: "HREC Manager", url: "/settings/hrecs" },
    ];

    return breadcrumbs;
};

export function HrecDetailsBreadcrumbs(hrecId: number, hrecName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.HANDHOLDINGHEART, title: "HREC Manager", url: "/settings/hrecs" },
        { icon: FontAwesomeIcons.Duotone.SCALEBALANCED, title: hrecName ? hrecName : "HREC", url: `/settings/hrecs/${hrecId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/settings/hrecs/${hrecId}/details` },
    ];

    return breadcrumbs;
};

export function HrecCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.HANDHOLDINGHEART, title: "HREC Manager", url: "/settings/hrecs" },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/hrecs/create" },
    ];

    return breadcrumbs;
};

export function HealthDistrictsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.HOSPITALS, title: "Health District Manager", url: "/settings/healthdistricts" },
    ];

    return breadcrumbs;
};

export function HealthDistrictDetailsBreadcrumbs(healthDistrictId: number, healthDistrictName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.HOSPITALS, title: "Health District Manager", url: "/settings/healthdistricts" },
        { icon: FontAwesomeIcons.Duotone.DISPLAYMEDICAL, title: healthDistrictName ? healthDistrictName : "Health District", url: `/settings/healthdistricts/${healthDistrictId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/settings/healthdistricts/${healthDistrictId}/details` },
    ];

    return breadcrumbs;
};

export function HealthDistrictCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.SETTINGS, title: "Settings", url: "/settings" },
        { icon: FontAwesomeIcons.Duotone.HOSPITALS, title: "Health District Manager", url: "/settings/healthdistricts" },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/settings/healthdistricts/create" },
    ];

    return breadcrumbs;
};

export function FellowshipsBreadcrumbs(personnelId: number, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/personnel/${personnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.BULIDINGCOLUMNS, title: "Fellowship", url: `/personnel/${personnelId}/fellowship` },
    ];

    return breadcrumbs;
};

export function FellowshipDetailsBreadcrumbs(personnelId: number, fellowshipId: number, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/personnel/${personnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.BULIDINGCOLUMNS, title: "Fellowship", url: `/personnel/${personnelId}/fellowship` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/personnel/${personnelId}/fellowship/${fellowshipId}/details` },
    ];

    return breadcrumbs;
};

export function FellowshipCreateBreadcrumbs(personnelId: number, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/personnel/${personnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.BULIDINGCOLUMNS, title: "Fellowship", url: `/personnel/${personnelId}/fellowship` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/personnel/${personnelId}/fellowship/create` },
    ];

    return breadcrumbs;
};

export function TrialsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
    ];

    return breadcrumbs;
};

export function TrialDetailsBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/trials/${trialId}/details` },
    ];

    return breadcrumbs;
};

export function TrialCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: "/trials/create" },
    ];

    return breadcrumbs;
};

export function TrialInstitutionsBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionDetailsBreadcrumbs(trialId: number, trialInstitutionId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionCreateBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/trialinstitution/create/details` }
    ];

    return breadcrumbs;
};

export function TrialInstitutionLaboratoriesBreadcrumbs(trialId: number, trialInstitutionId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionLaboratoryBreadcrumbs(
    trialId: number, 
    trialInstitutionId: number, 
    trialInstitutionLaboratoryId: number, 
    trialName?: string, 
    trialInstitutionName?: string, 
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}/details` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionLaboratoryCreateBreadcrumbs(
    trialId: number, 
    trialInstitutionId: number,  
    trialName?: string, 
    trialInstitutionName?: string, 
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/create` }
    ];

    return breadcrumbs;
};

export function TrialInstitutionMonitoringsBreadcrumbs(trialId: number, trialInstitutionId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONITOR, title: "Monitoring", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionMonitoringDetailsBreadcrumbs(trialId: number, trialInstitutionId: number, monitoringId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONITOR, title: "Monitoring", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/details` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionMonitoringCreateBreadcrumbs(trialId: number, trialInstitutionId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONITOR, title: "Monitoring", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/create` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionMonitoringDocumentsBreadcrumbs(trialId: number, trialInstitutionId: number, monitoringId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONITOR, title: "Monitoring", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring` },
        { icon: FontAwesomeIcons.Duotone.FILE, title: "Documents", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/documents` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionMonitoringDocumentDetailsBreadcrumbs(trialId: number, trialInstitutionId: number, monitoringId: number, monitoringDocumentId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONITOR, title: "Monitoring", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring` },
        { icon: FontAwesomeIcons.Duotone.FILE, title: "Documents", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/documents` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/documents/${monitoringDocumentId}/details` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionMonitoringDocumentCreateBreadcrumbs(trialId: number, trialInstitutionId: number, monitoringId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONITOR, title: "Monitoring", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring` },
        { icon: FontAwesomeIcons.Duotone.FILE, title: "Documents", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/documents` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/documents/create` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionMonitoringIssuesBreadcrumbs(trialId: number, trialInstitutionId: number, monitoringId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONITOR, title: "Monitoring", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring` },
        { icon: FontAwesomeIcons.Duotone.MONITORINGISSUE, title: "Issues", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionMonitoringIssueDetailsBreadcrumbs(trialId: number, trialInstitutionId: number, monitoringId: number, monitoringIssueId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONITOR, title: "Monitoring", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring` },
        { icon: FontAwesomeIcons.Duotone.MONITORINGISSUE, title: "Issues", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues/${monitoringIssueId}/details` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionMonitoringIssueCreateBreadcrumbs(trialId: number, trialInstitutionId: number, monitoringId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONITOR, title: "Monitoring", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring` },
        { icon: FontAwesomeIcons.Duotone.MONITORINGISSUE, title: "Issues", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues/create` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionMonitoringIssueDocumentsBreadcrumbs(trialId: number, trialInstitutionId: number, monitoringId: number, monitoringIssueId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONITOR, title: "Monitoring", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring` },
        { icon: FontAwesomeIcons.Duotone.MONITORINGISSUE, title: "Issues", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues` },
        { icon: FontAwesomeIcons.Duotone.FILE, title: "Documents", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues/${monitoringIssueId}/documents` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionMonitoringIssueDocumentDetailsBreadcrumbs(trialId: number, trialInstitutionId: number, monitoringId: number, monitoringIssueId: number, monitoringIssueDocumentId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONITOR, title: "Monitoring", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring` },
        { icon: FontAwesomeIcons.Duotone.MONITORINGISSUE, title: "Issues", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues` },
        { icon: FontAwesomeIcons.Duotone.FILE, title: "Documents", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues/${monitoringIssueId}/documents` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues/${monitoringIssueId}/documents/${monitoringIssueDocumentId}/details` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionMonitoringIssueDocumentCreateBreadcrumbs(trialId: number, trialInstitutionId: number, monitoringId: number, monitoringIssueId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONITOR, title: "Monitoring", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring` },
        { icon: FontAwesomeIcons.Duotone.MONITORINGISSUE, title: "Issues", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues` },
        { icon: FontAwesomeIcons.Duotone.FILE, title: "Documents", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues/${monitoringIssueId}/documents` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues/${monitoringIssueId}/documents/create` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionLaboratoryFinanceBreadcrumbs(
    trialId: number, 
    trialInstitutionId: number, 
    trialInstitutionLaboratoryId: number, 
    trialName?: string, 
    trialInstitutionName?: string, 
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN, title: "Finance", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}/finance` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionLaboratoryContractsBreadcrumbs(
    trialId: number, 
    trialInstitutionId: number, 
    trialInstitutionLaboratoryId: number, 
    trialName?: string, 
    trialInstitutionName?: string, 
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}/contracts` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionLaboratoryContractDetailsBreadcrumbs(
    trialId: number, 
    trialInstitutionId: number, 
    trialInstitutionLaboratoryId: number,
    trialInstitutionLaboratoryContractId: number,
    trialName?: string, 
    trialInstitutionName?: string, 
    laboratoryName?: string,
    contractName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}/contracts` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: contractName ? contractName : "Contract", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}/contracts/${trialInstitutionLaboratoryContractId}/details` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionLaboratoryContractCreateBreadcrumbs(
    trialId: number, 
    trialInstitutionId: number, 
    trialInstitutionLaboratoryId: number,
    trialName?: string, 
    trialInstitutionName?: string, 
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}/contracts` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}/contracts/create` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionLaboratoryPersonnelsBreadcrumbs(
    trialId: number, 
    trialInstitutionId: number, 
    trialInstitutionLaboratoryId: number, 
    trialName?: string, 
    trialInstitutionName?: string, 
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}/personnel` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionLaboratoryPersonnelBreadcrumbs(
    trialId: number, 
    trialInstitutionId: number, 
    trialInstitutionLaboratoryId: number, 
    trialInstitutionLaboratoryPersonnelId: number, 
    trialName?: string, 
    trialInstitutionName?: string, 
    laboratoryName?: string,
    personnelName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARDUSER, title: personnelName ? personnelName : "Personnel", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}/personnel/${trialInstitutionLaboratoryPersonnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}/personnel/${trialInstitutionLaboratoryPersonnelId}/details` }
    ];

    return breadcrumbs;
};

export function TrialInstitutionLaboratoryPersonnelCreateBreadcrumbs(
    trialId: number, 
    trialInstitutionId: number, 
    trialInstitutionLaboratoryId: number, 
    trialName?: string, 
    trialInstitutionName?: string, 
    laboratoryName?: string,
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Personnel", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}/personnel/create` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionItemsBreadcrumbs(trialId: number, trialInstitutionId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.I, title: "Items", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/items` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionFinanceBreadcrumbs(trialId: number, trialInstitutionId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN, title: "Finance", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/finance` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionContractsBreadcrumbs(trialId: number, trialInstitutionId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/contracts` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionContractDetailsBreadcrumbs(trialId: number, trialInstitutionId: number, trialInstitutionContractId: number, trialName?: string, trialInstitutionName?: string, contractName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/contracts` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: contractName ? contractName : "Personnel", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/contracts/${trialInstitutionContractId}/details` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionContractCreateBreadcrumbs(trialId: number, trialInstitutionId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/contracts` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/contracts/create` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionPersonnelsBreadcrumbs(trialId: number, trialInstitutionId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/personnel` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionPersonnelDetailsBreadcrumbs(
    trialId: number, 
    trialInstitutionId: number, 
    personnelId: number, 
    trialName?: string, 
    trialInstitutionName?: string, 
    personnelName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARDUSER, title: personnelName ? personnelName : "Personnel", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/personnel/${personnelId}/details` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionPersonnelCreateBreadcrumbs(
    trialId: number, 
    trialInstitutionId: number,
    trialName?: string, 
    trialInstitutionName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/personnel/create` }
    ];

    return breadcrumbs;
};

export function TrialInstitutionNotesBreadcrumbs(trialId: number, trialInstitutionId: number, trialName?: string, trialInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: "Notes", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/notes` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionNoteBreadcrumbs(
    trialId: number, 
    trialInstitutionId: number, 
    noteId: number, 
    trialName?: string, 
    trialInstitutionName?: string,
    noteName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: "Notes", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/notes` },
        { icon: FontAwesomeIcons.Duotone.NOTE, title: noteName? noteName : "Note", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/notes/${noteId}/details` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionNoteCreateBreadcrumbs(
    trialId: number, 
    trialInstitutionId: number,
    trialName?: string, 
    trialInstitutionName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/trials/${trialId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: trialInstitutionName ? trialInstitutionName : "Institution", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: "Notes", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/notes` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/notes/create` },
    ];

    return breadcrumbs;
};

export function TrialFormsBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.MEMOPAD, title: "Forms", url: `/trials/${trialId}/forms` },
    ];

    return breadcrumbs;
};

export function TrialFormBreadcrumbs(trialId: number, formId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.MEMOPAD, title: "Forms", url: `/trials/${trialId}/forms` },
        { icon: FontAwesomeIcons.Duotone.NOTE, title: "Trial Form", url: `/trials/${trialId}/forms/${formId}` },
    ];

    return breadcrumbs;
};

export function TrialFormEntryBreadcrumbs(trialId: number, formId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.MEMOPAD, title: "Forms", url: `/trials/${trialId}/forms` },
        { icon: FontAwesomeIcons.Duotone.NOTE, title: "Trial Form", url: `/trials/${trialId}/forms/${formId}` },
        { icon: FontAwesomeIcons.Duotone.DUNGEON, title: "Entry", url: `/trials/${trialId}/forms/${formId}/entry` },
    ];

    return breadcrumbs;
};

export function TrialFormReportBreadcrumbs(trialId: number, formId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.MEMOPAD, title: "Forms", url: `/trials/${trialId}/forms` },
        { icon: FontAwesomeIcons.Duotone.NOTE, title: "Trial Form", url: `/trials/${trialId}/forms/${formId}` },
        { icon: FontAwesomeIcons.Duotone.EXCLAMATION, title: "Report", url: `/trials/${trialId}/forms/${formId}/report` },
    ];

    return breadcrumbs;
};

export function TrialInstitutionItemCustomViewBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.I, title: "Institution Item Views", url: `/trials/${trialId}/trialinstitutionitemviews` },
    ];

    return breadcrumbs;
};

export function TrialItemsBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.I, title: "Items", url: `/trials/${trialId}/trialitems` },
    ];

    return breadcrumbs;
};

export function TrialItemBreadcrumbs(trialId: number, itemId: number, trialName?: string, itemName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.I, title: "Trial Items", url: `/trials/${trialId}/trialitems` },
        { icon: FontAwesomeIcons.Duotone.INFO, title: itemName ? itemName : "Item", url: `/trials/${trialId}/trialitems/${itemId}` },
    ];

    return breadcrumbs;
};

export function TrialPersonnelsBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/trials/${trialId}/personnel` },
    ];

    return breadcrumbs;
};

export function TrialPersonnelBreadcrumbs(
    trialId: number,
    personnelId: number, 
    trialName?: string,
    personnelName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/trials/${trialId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/trials/${trialId}/personnel/${personnelId}/details` },
    ];

    return breadcrumbs;
};

export function TrialPersonnelCreateBreadcrumbs(
    trialId: number,
    trialName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/trials/${trialId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/personnel/create` }
    ];

    return breadcrumbs;
};

export function TrialNotesBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: "Notes", url: `/trials/${trialId}/notes` },
    ];

    return breadcrumbs;
};

export function TrialNoteBreadcrumbs(trialId: number, noteId: number, trialName?: string, noteName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: "Notes", url: `/trials/${trialId}/notes` },
        { icon: FontAwesomeIcons.Duotone.NOTE, title: noteName ? noteName : "Note", url: `/trials/${trialId}/notes/${noteId}` },
    ];

    return breadcrumbs;
};

export function TrialNoteCreateBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: "Notes", url: `/trials/${trialId}/notes` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/notes/create` },
    ];

    return breadcrumbs;
};

export function TrialGroupsBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
    ];

    return breadcrumbs;
};

export function TrialGroupBreadcrumbs(trialId: number, groupId: number, trialName?: string, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/details` },
    ];

    return breadcrumbs;
};

export function TrialProjectDetailsBreadcrumbs(trialId: number, trialName?: string, projectName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: projectName ? projectName : "Project", url: `/trials/${trialId}/project/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/trials/${trialId}/project/details` },
    ];

    return breadcrumbs;
};

export function TrialProjectInvestigatorsBreadcrumbs(trialId: number, investigatorId: number, trialName?: string, projectName?: string, investigatorName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: projectName ? projectName : "Project", url: `/trials/${trialId}/project/details` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Project Investigators", url: `/trials/${trialId}/project/investigators/${investigatorId}/details` },
        { icon: FontAwesomeIcons.Duotone.RAMPLOADING, title: investigatorName ? investigatorName : "Investigator", url: `/trials/${trialId}/project/investigators/${investigatorId}/details` },
    ];

    return breadcrumbs;
};

export function TrialProjectDiscussionsBreadcrumbs(trialId: number, trialName?: string, projectName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: projectName ? projectName : "Project", url: `/trials/${trialId}/project/details` },
        { icon: FontAwesomeIcons.Duotone.COMMENTS, title: "Discussions", url: `/trials/${trialId}/project/discussions` },
    ];

    return breadcrumbs;
};

export function TrialProjectDiscussionDetailsBreadcrumbs(trialId: number, discussionId: number, trialName?: string, projectName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: projectName ? projectName : "Project", url: `/trials/${trialId}/project/details` },
        { icon: FontAwesomeIcons.Duotone.COMMENTS, title: "Discussions", url: `/trials/${trialId}/project/discussions` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/trials/${trialId}/project/discussions/${discussionId}/details` },
    ];

    return breadcrumbs;
};

export function TrialProjectDiscussionCreateBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Project", url: `/trials/${trialId}/project/details` },
        { icon: FontAwesomeIcons.Duotone.COMMENTS, title: "Discussions", url: `/trials/${trialId}/project/discussions` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/project/discussions/create` },
    ];

    return breadcrumbs;
};

export function TrialProjectItemsBreadcrumbs(trialId: number, trialName?: string, projectName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: projectName ? projectName : "Project", url: `/trials/${trialId}/project/details` },
        { icon: FontAwesomeIcons.Duotone.I, title: "Items", url: `/trials/${trialId}/project/items` },
    ];

    return breadcrumbs;
};

export function TrialAccrualsBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.CHARTLINE, title: "Accrual", url: `/trials/${trialId}/accrual` },
    ];

    return breadcrumbs;
};

export function TrialDoiDetailsBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.RIGHTLEFTLARGE, title: "Data Sharing", url: `/trials/${trialId}/datasharing` },
    ];

    return breadcrumbs;
};

export function TrialFinanceBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN, title: "Finance", url: `/trials/${trialId}/finance` },
    ];

    return breadcrumbs;
};

export function TrialWebsiteDetailsBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GLOBEPOINTER, title: "Website", url: `/trials/${trialId}/website` },
    ];

    return breadcrumbs;
};

export function TrialItemUpdateBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.SPARKLES, title: "Item Update", url: `/trials/${trialId}/trialitemupdate` },
    ];

    return breadcrumbs;
};

export function TrialLaboratoriesBreadcrumbs(trialId: number, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/labs` },
    ];

    return breadcrumbs;
};

export function CommitteesBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committee", url: "/committees" },
    ];

    return breadcrumbs;
};

export function CommitteesCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/committees/create` },
    ];

    return breadcrumbs;
};

export function CommitteeDetailsBreadcrumbs(committeeId: number, committeeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/committees/${committeeId}/details` },
    ];

    return breadcrumbs;
};

export function CommitteeMeetingsBreadcrumbs(committeeId: number, committeeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.HANDSHAKE, title: "Meetings", url: `/committees/${committeeId}/meetings` },
    ];

    return breadcrumbs;
};

export function CommitteeMeetingDetailsBreadcrumbs(committeeId: number, committeeMeetingId: number, committeeName?: string, committeeMeetingName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.HANDSHAKE, title: "Meetings", url: `/committees/${committeeId}/meetings` },
        { icon: FontAwesomeIcons.Duotone.BOOTHCURTAIN, title: committeeMeetingName ? committeeMeetingName : "Meeting", url: `/committees/${committeeId}/meetings/${committeeMeetingId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/committees/${committeeId}/meetings/${committeeMeetingId}/details` },
    ];

    return breadcrumbs;
};

export function CommitteeMeetingCreateBreadcrumbs(committeeId: number, committeeMeetingId: number, committeeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.HANDSHAKE, title: "Meetings", url: `/committees/${committeeId}/meetings` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/committees/${committeeId}/meetings/create` },
    ];

    return breadcrumbs;
};

export function CommitteeMeetingAttendancesBreadcrumbs(committeeId: number, committeeMeetingId: number, committeeName?: string, committeeMeetingName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.HANDSHAKE, title: "Meetings", url: `/committees/${committeeId}/meetings` },
        { icon: FontAwesomeIcons.Duotone.BOOTHCURTAIN, title: committeeMeetingName ? committeeMeetingName : "Meeting", url: `/committees/${committeeId}/meetings/${committeeMeetingId}/details` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARDUSER, title: "Attendances", url: `/committees/${committeeId}/meetings/${committeeMeetingId}/attendances` },
    ];

    return breadcrumbs;
};

export function CommitteeMeetingAttendanceDetailsBreadcrumbs(committeeId: number, committeeMeetingId: number, committeeMeetingAttendanceId: number, committeeName?: string, committeeMeetingName?: string, committeeMeetingAttendanceName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.HANDSHAKE, title: "Meetings", url: `/committees/${committeeId}/meetings` },
        { icon: FontAwesomeIcons.Duotone.BOOTHCURTAIN, title: committeeMeetingName ? committeeMeetingName : "Meeting", url: `/committees/${committeeId}/meetings/${committeeMeetingId}/details` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARDUSER, title: "Attendances", url: `/committees/${committeeId}/meetings/${committeeMeetingId}/attendances` },
        { icon: FontAwesomeIcons.Duotone.USER, title: committeeMeetingAttendanceName ? committeeMeetingAttendanceName : "Attendee", url: `/committees/${committeeId}/meetings/${committeeMeetingId}/attendances/${committeeMeetingAttendanceId}/details` },
    ];

    return breadcrumbs;
};

export function CommitteeMeetingAttendanceCreateBreadcrumbs(committeeId: number, committeeMeetingId: number, committeeName?: string, committeeMeetingName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.HANDSHAKE, title: "Meetings", url: `/committees/${committeeId}/meetings` },
        { icon: FontAwesomeIcons.Duotone.BOOTHCURTAIN, title: committeeMeetingName ? committeeMeetingName : "Meeting", url: `/committees/${committeeId}/meetings/${committeeMeetingId}/details` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARDUSER, title: "Attendances", url: `/committees/${committeeId}/meetings/${committeeMeetingId}/attendances` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/committees/${committeeId}/meetings/${committeeMeetingId}/attendances/create` },
    ];

    return breadcrumbs;
};

export function CommitteeMembersBreadcrumbs(committeeId: number, committeeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Members", url: `/committees/${committeeId}/members` },
    ];

    return breadcrumbs;
};

export function CommitteeMemberDetailsBreadcrumbs(committeeId: number, committeeMemberId: number, committeeName?: string, committeeMemberName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Members", url: `/committees/${committeeId}/members` },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: committeeMemberName ? committeeMemberName : "Member", url: `/committees/${committeeId}/members/${committeeMemberId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/committees/${committeeId}/members/${committeeMemberId}/details` },
    ];

    return breadcrumbs;
};

export function CommitteeMemberCreateBreadcrumbs(committeeId: number, committeeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Members", url: `/committees/${committeeId}/members` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/committees/${committeeId}/members/create` },
    ];

    return breadcrumbs;
};

export function CommitteeMemberRolesBreadcrumbs(committeeId: number, committeeMemberId: number, committeeName?: string, committeeMemberName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Members", url: `/committees/${committeeId}/members` },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: committeeMemberName ? committeeMemberName : "Member", url: `/committees/${committeeId}/members/${committeeMemberId}/details` },
        { icon: FontAwesomeIcons.Duotone.USERSHIELD, title: "Roles", url: `/committees/${committeeId}/members/${committeeMemberId}/roles` },
    ];

    return breadcrumbs;
};

export function CommitteeMemberRoleDetailsBreadcrumbs(committeeId: number, committeeMemberId: number, committeeMemberRoleId: number, committeeName?: string, committeeMemberName?: string, committeeMemberRoleName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Members", url: `/committees/${committeeId}/members` },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: committeeMemberName ? committeeMemberName : "Member", url: `/committees/${committeeId}/members/${committeeMemberId}/details` },
        { icon: FontAwesomeIcons.Duotone.USERSHIELD, title: "Roles", url: `/committees/${committeeId}/members/${committeeMemberId}/roles` },
        { icon: FontAwesomeIcons.Duotone.ROLE, title: committeeMemberRoleName ? committeeMemberRoleName : "Role", url: `/committees/${committeeId}/members/${committeeMemberId}/roles/${committeeMemberRoleId}/details` },
    ];

    return breadcrumbs;
};

export function CommitteeMemberRoleCreateBreadcrumbs(committeeId: number, committeeMemberId: number, committeeName?: string, committeeMemberName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Members", url: `/committees/${committeeId}/members` },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: committeeMemberName ? committeeMemberName : "Member", url: `/committees/${committeeId}/members/${committeeMemberId}/details` },
        { icon: FontAwesomeIcons.Duotone.USERSHIELD, title: "Roles", url: `/committees/${committeeId}/members/${committeeMemberId}/roles` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/committees/${committeeId}/members/${committeeMemberId}/roles/create` },
    ];

    return breadcrumbs;
};

export function CommitteeRegularInviteesBreadcrumbs(committeeId: number, committeeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.CALENDARCIRCLEUSER, title: "Regular Invitees", url: `/committees/${committeeId}/regularinvitees` },
    ];

    return breadcrumbs;
};

export function CommitteeRegularInviteeDetailsBreadcrumbs(committeeId: number, committeeRegularInviteeId: number, committeeName?: string, committeeRegularInviteeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.CALENDARCIRCLEUSER, title: "Regular Invitees", url: `/committees/${committeeId}/regularinvitees` },
        { icon: FontAwesomeIcons.Duotone.USER, title: committeeRegularInviteeName ? committeeRegularInviteeName : "Regular Invitee", url: `/committees/${committeeId}/regularinvitees/${committeeRegularInviteeId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/committees/${committeeId}/regularinvitees/${committeeRegularInviteeId}/details` },
    ];

    return breadcrumbs;
};

export function CommitteeRegularInviteeCreateBreadcrumbs(committeeId: number, committeeRegularInviteeId: number, committeeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.COMMITTEE, title: "Committees", url: "/committees" },
        { icon: FontAwesomeIcons.Duotone.USERSVIEWFINDER, title: committeeName ? committeeName : "Committee", url: `/committees/${committeeId}/details` },
        { icon: FontAwesomeIcons.Duotone.CALENDARCIRCLEUSER, title: "Regular Invitees", url: `/committees/${committeeId}/regularinvitees` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/committees/${committeeId}/regularinvitees/create` },
    ];

    return breadcrumbs;
};

export function GroupsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
    ];

    return breadcrumbs;
};

export function GroupsCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/groups/create` },
    ];

    return breadcrumbs;
};

export function GroupDetailsBreadcrumbs(groupId: number, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/groups/${groupId}/details` },
    ];

    return breadcrumbs;
};

export function GroupTrialsBreadcrumbs(groupId: number, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
    ];

    return breadcrumbs;
};

export function GroupPersonnelsBreadcrumbs(groupId: number, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/groups/${groupId}/personnel` },
    ];

    return breadcrumbs;
};

export function GroupPersonnelCreateBreadcrumbs(groupId: number, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/groups/${groupId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/groups/${groupId}/personnel/create`},
    ];

    return breadcrumbs;
};

export function GroupPersonnelDetailsBreadcrumbs(groupId: number, personnelId: number, groupName?: string, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/groups/${groupId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/groups/${groupId}/personnel/${personnelId}/details` },
    ];

    return breadcrumbs;
};

export function GroupTrialDetailsBreadcrumbs(groupId: number, trialId: number,  trialGroupId: number, groupName?: string, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
    ];

    return breadcrumbs;
};

export function GroupTrialPersonnelsBreadcrumbs(groupId: number, trialId: number,  trialGroupId: number, groupName?: string, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/personnel` },
    ];

    return breadcrumbs;
};

export function GroupTrialPersonnelDetailsBreadcrumbs(groupId: number, trialId: number,  trialGroupId: number, trialPersonnelId: number, groupName?: string, trialName?: string, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARDUSER, title: personnelName ? personnelName : "Personnel", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/personnel/${trialPersonnelId}/details` },
    ];

    return breadcrumbs;
};

export function GroupTrialPersonnelCreateBreadcrumbs(groupId: number, trialId: number, trialGroupId: number, groupName?: string, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/personnel/create`},
    ];

    return breadcrumbs;
};

export function GroupTrialItemsBreadcrumbs(trialId: number, groupId: number, trialGroupId: number, trialName?: string, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.I, title: "Items", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/items` },
    ];

    return breadcrumbs;
};

export function GroupTrialLaboratoriesBreadcrumbs(trialId: number, groupId: number, trialGroupId: number, trialName?: string, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs` },
    ];

    return breadcrumbs;
};

export function GroupTrialLaboratoryDetailsBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number, 
    trialGroupLaboratoryId: number, 
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/details` },
    ];

    return breadcrumbs;
};

export function GroupTrialLaboratoryCreateBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number,
    trialName?: string, 
    groupName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/create`},
    ];

    return breadcrumbs;
};

export function GroupTrialLaboratoryPersonnelsBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number, 
    trialGroupLaboratoryId: number, 
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel` },
    ];

    return breadcrumbs;
};

export function GroupTrialLaboratoryPersonnelBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number,
    trialGroupLaboratoryId: number, 
    trialGroupLaboratoryPersonnelId: number, 
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string,
    personnelName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARDUSER, title: personnelName ? personnelName : "Personnel", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel/${trialGroupLaboratoryPersonnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel/${trialGroupLaboratoryPersonnelId}/details` }
    ];

    return breadcrumbs;
};

export function GroupTrialLaboratoryPersonnelCreateBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number,
    trialGroupLaboratoryId: number,
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel/create`},
    ];

    return breadcrumbs;
};

export function GroupTrialLaboratoryContractsBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number, 
    trialGroupLaboratoryId: number, 
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/contracts` },
    ];

    return breadcrumbs;
};

export function GroupTrialLaboratoryContractDetailsBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number,
    trialGroupLaboratoryId: number, 
    trialGroupLaboratoryContractId: number, 
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string,
    contractName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/contracts` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: contractName ? contractName : "Contract", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/contracts/${trialGroupLaboratoryContractId}/details` },
    ];

    return breadcrumbs;
};

export function GroupTrialLaboratoryContractCreateBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number,
    trialGroupLaboratoryId: number,
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/contracts` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/contracts/create`},
    ];

    return breadcrumbs;
};

export function GroupTrialLaboratoryFinanceBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number, 
    trialGroupLaboratoryId: number, 
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN, title: "Finance", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/finance` },
    ];

    return breadcrumbs;
};

export function GroupTrialFinanceBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number, 
    trialName?: string, 
    groupName?: string,
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN, title: "Finance", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/finance` }
    ];

    return breadcrumbs;
};

export function GroupTrialContractsBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number, 
    trialName?: string, 
    groupName?: string,
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/contracts` }
    ];

    return breadcrumbs;
};

export function GroupTrialContractDetailsBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number,
    trialGroupContractId: number,
    trialName?: string, 
    groupName?: string,
    contractName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/contracts` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: contractName ? contractName : "Contract", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/contracts/${trialGroupContractId}/details` }
    ];

    return breadcrumbs;
};

export function GroupTrialContractCreateBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number,
    trialName?: string, 
    groupName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/groups/${groupId}/trials` },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/contracts` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/contracts/create` }
    ];

    return breadcrumbs;
};

export function TrialGroupDetailsBreadcrumbs(groupId: number, trialId: number,  trialGroupId: number, groupName?: string, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
    ];

    return breadcrumbs;
};

export function TrialGroupPersonnelsBreadcrumbs(groupId: number, trialId: number,  trialGroupId: number, groupName?: string, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/personnel` },
    ];

    return breadcrumbs;
};

export function TrialGroupPersonnelDetailsBreadcrumbs(groupId: number, trialId: number,  trialGroupId: number, trialPersonnelId: number, groupName?: string, trialName?: string, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARDUSER, title: personnelName ? personnelName : "Personnel", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/personnel/${trialPersonnelId}/details` },
    ];

    return breadcrumbs;
};

export function TrialGroupPersonnelCreateBreadcrumbs(groupId: number, trialId: number,  trialGroupId: number, groupName?: string, trialName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/personnel/create`},
    ];

    return breadcrumbs;
};

export function TrialGroupItemsBreadcrumbs(trialId: number, groupId: number, trialGroupId: number, trialName?: string, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.I, title: "Items", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/items` },
    ];

    return breadcrumbs;
};

export function TrialGroupLaboratoriesBreadcrumbs(trialId: number, groupId: number, trialGroupId: number, trialName?: string, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs` },
    ];

    return breadcrumbs;
};

export function TrialGroupLaboratoryDetailsBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number, 
    trialGroupLaboratoryId: number, 
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/details` },
    ];

    return breadcrumbs;
};

export function TrialGroupLaboratoryCreateBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number,
    trialName?: string, 
    groupName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/create`},
    ];

    return breadcrumbs;
};

export function TrialGroupLaboratoryPersonnelsBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number, 
    trialGroupLaboratoryId: number, 
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel` },
    ];

    return breadcrumbs;
};

export function TrialGroupLaboratoryPersonnelBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number,
    trialGroupLaboratoryId: number, 
    trialGroupLaboratoryPersonnelId: number, 
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string,
    personnelName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARDUSER, title: personnelName ? personnelName : "Personnel", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel/${trialGroupLaboratoryPersonnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel/${trialGroupLaboratoryPersonnelId}/details` }
    ];

    return breadcrumbs;
};

export function TrialGroupLaboratoryPersonnelCreateBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number,
    trialGroupLaboratoryId: number,
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel/create`},
    ];

    return breadcrumbs;
};

export function TrialGroupLaboratoryFinanceBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number, 
    trialGroupLaboratoryId: number, 
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN, title: "Finance", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/finance` },
    ];

    return breadcrumbs;
};

export function TrialGroupLaboratoryContractsBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number, 
    trialGroupLaboratoryId: number, 
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/contracts` },
    ];

    return breadcrumbs;
};

export function TrialGroupLaboratoryContractDetailsBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number,
    trialGroupLaboratoryId: number, 
    trialGroupLaboratoryContractId: number, 
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string,
    contractName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contract", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/contracts` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: contractName ? contractName : "Contract", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/contracts/${trialGroupLaboratoryContractId}/details` },
    ];

    return breadcrumbs;
};

export function TrialGroupLaboratoryContractCreateBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number,
    trialGroupLaboratoryId: number,
    trialName?: string, 
    groupName?: string,
    laboratoryName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/contracts` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/contracts/create`},
    ];

    return breadcrumbs;
};

export function TrialGroupFinanceBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number, 
    trialName?: string, 
    groupName?: string,
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN, title: "Finance", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/finance` }
    ];

    return breadcrumbs;
};

export function TrialGroupContractsBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number, 
    trialName?: string, 
    groupName?: string,
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/contracts` }
    ];

    return breadcrumbs;
};

export function TrialGroupContractDetailsBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number,
    trialGroupContractId: number,
    trialName?: string, 
    groupName?: string,
    contractName?: string
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/contracts` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: contractName ? contractName : "Contract", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/contracts/${trialGroupContractId}/details` }
    ];

    return breadcrumbs;
};

export function TrialGroupContractCreateBreadcrumbs(
    trialId: number, 
    groupId: number,
    trialGroupId: number,
    trialName?: string, 
    groupName?: string,
): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: "/trials" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: trialName ? trialName : "Trial", url: `/trials/${trialId}/details` },
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: `/trials/${trialId}/groups` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: groupName ? groupName : "Group", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contracts", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/contracts` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/contracts/create` }
    ];

    return breadcrumbs;
};

export function GroupNotesBreadcrumbs(groupId: number, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: "Notes", url: `/groups/${groupId}/notes` },
    ];

    return breadcrumbs;
};

export function GroupsNoteBreadcrumbs(groupId: number, noteId: number, groupName?: string, noteName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: "Notes", url: `/groups/${groupId}/notes` },
        { icon: FontAwesomeIcons.Duotone.NOTE, title: noteName ? noteName : "Note", url: `/groups/${groupId}/notes/${noteId}/details` },
    ];

    return breadcrumbs;
};

export function GroupsNoteCreateBreadcrumbs(groupId: number, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: "Notes", url: `/groups/${groupId}/notes` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/groups/${groupId}/notes/create` }
    ];

    return breadcrumbs;
};

export function GroupPersonnelBreadcrumbs(groupId: number, personnelId: number, groupName?: string, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.USERGROUPSIMPLE, title: "Members", url: `/groups/${groupId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Member", url: `/groups/${groupId}/personnel/${personnelId}` },
    ];

    return breadcrumbs;
};

export function GroupMeetingsBreadcrumbs(groupId: number, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.HANDSHAKE, title: "Meetings", url: `/groups/${groupId}/meetings` },
    ];

    return breadcrumbs;
};

export function GroupRegularInviteesBreadcrumbs(groupId: number, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.CALENDARCIRCLEUSER, title: "Regular Invitees", url: `/groups/${groupId}/regularInvitees` },
    ];

    return breadcrumbs;
};

export function GroupContractBreadcrumbs(groupId: number, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contract", url: `/groups/${groupId}/contracts` },
    ];

    return breadcrumbs;
};

export function GroupContractCreateBreadcrumbs(groupId: number, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contract", url: `/groups/${groupId}/contracts` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/groups/${groupId}/contracts`},
    ];

    return breadcrumbs;
};

export function GroupFinanceBreadcrumbs(groupId: number, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN, title: "Finance", url: `/groups/${groupId}/finances` },
    ];

    return breadcrumbs;
};

export function GroupFinanceCreateBreadcrumbs(groupId: number, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Finance", url: `/groups/${groupId}/finances` },
        { icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN, title: "Create", url: `/groups/${groupId}/finances`},
    ];

    return breadcrumbs;
};

export function GroupItemsBreadcrumbs(groupId: number, groupName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.GROUP, title: "Groups", url: "/groups" },
        { icon: FontAwesomeIcons.Duotone.GROUPARROWSROTATE, title: groupName ? groupName : "Group", url: `/groups/${groupId}/details` },
        { icon: FontAwesomeIcons.Duotone.I, title: "Items", url: `/groups/${groupId}/items` },
    ];

    return breadcrumbs;
};

export function PersonnelsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
    ];

    return breadcrumbs;
};

export function PersonnelCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/personnel/create` },
    ];

    return breadcrumbs;
};

export function PersonnelDetailsBreadcrumbs(personnelId: number, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/personnel/${personnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/personnel/${personnelId}/details` },
    ];

    return breadcrumbs;
};

export function PersonnelByRoleBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: "Personnel by Role", url: `/personnel/byroles` },
    ];

    return breadcrumbs;
};

export function PersonnelTrainingBreadcrumbs(personnelId: number, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/personnel/${personnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECERTIFICATE, title: "Training & Certification", url: `/personnel/${personnelId}/trainingcertifications` },
    ];

    return breadcrumbs;
};

export function PersonnelRolesBreadcrumbs(personnelId: number, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/personnel/${personnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGSHIELD, title: "Roles", url: `/personnel/${personnelId}/roles` },
    ];

    return breadcrumbs;
};

export function PersonnelRoleBreadcrumbs(personnelId: number, roleId: number, personnelName?: string, roleName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/personnel/${personnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGSHIELD, title: "Roles", url: `/personnel/${personnelId}/roles` },
        { icon: FontAwesomeIcons.Duotone.SHIELDHALVED, title: roleName ? roleName : "Role", url: `/personnel/${personnelId}/roles/${roleId}/details` },
    ];

    return breadcrumbs;
};

export function PersonnelRoleCreateBreadcrumbs(personnelId: number, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/personnel/${personnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGSHIELD, title: "Roles", url: `/personnel/${personnelId}/roles` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/personnel/${personnelId}/roles/create` },
    ];

    return breadcrumbs;
};

export function PersonnelPermissionsBreadcrumbs(personnelId: number, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/personnel/${personnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.USERSHIELD, title: "Permissions", url: `/personnel/${personnelId}/permissions` },
    ];

    return breadcrumbs;
};

export function PersonnelOpenClinicaBreadcrumbs(personnelId: number, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/personnel/${personnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.OPENCLINICA, title: "Open Clincia", url: `/personnel/${personnelId}/openclinica` },
    ];

    return breadcrumbs;
};

export function PersonnelActiveDirectoryBreadcrumbs(personnelId: number, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/personnel/${personnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.SHIELDHALVED, title: "Login & Security", url: `/personnel/${personnelId}/activedirectory` },
    ];

    return breadcrumbs;
};

export function PersonnelNotesBreadcrumbs(personnelId: number, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/personnel/${personnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: "Notes", url: `/personnel/${personnelId}/notes` },
    ];

    return breadcrumbs;
};

export function PersonnelNoteBreadcrumbs(personnelId: number, noteId: number, personnelName?: string, noteName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/personnel/${personnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: "Notes", url: `/personnel/${personnelId}/notes` },
        { icon: FontAwesomeIcons.Duotone.NOTE, title: noteName ? noteName : "Note", url: `/personnel/${personnelId}/notes/${noteId}/details` },
    ];

    return breadcrumbs;
};

export function PersonnelNoteCreateBreadcrumbs(personnelId: number, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: "/personnel" },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/personnel/${personnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: "Notes", url: `/personnel/${personnelId}/notes` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/personnel/${personnelId}/notes/create` }
    ];

    return breadcrumbs;
};

export function MyTrialsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.BLOCK, title: "My trials", url: "/mytrials" },
    ];

    return breadcrumbs;
};

export function ProjectsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/projects" },
    ];

    return breadcrumbs;
};

export function ProjectDetailsBreadcrumbs(projectId: number, projectName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/projects" },
        { icon: FontAwesomeIcons.Duotone.DICED20, title: projectName ? projectName : "Project", url: `/projects/${projectId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/projects/${projectId}/details` },
    ];

    return breadcrumbs;
};

export function ProjectCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/projects" },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/projects/create` },
    ];

    return breadcrumbs;
};

export function ProjectItemsBreadcrumbs(projectId: number, projectName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/projects" },
        { icon: FontAwesomeIcons.Duotone.DICED20, title: projectName ? projectName : "Project", url: `/projects/${projectId}/details` },
        { icon: FontAwesomeIcons.Duotone.I, title: "Items", url: `/projects/${projectId}/items` },
    ];

    return breadcrumbs;
};

export function ProjectInvestigatorsBreadcrumbs(projectId: number, investigatorId: number, projectName?: string, investigatorName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Projects", url: "/projects" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: projectName ? projectName : "Project", url: `/projects/${projectId}/details` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Project Investigators", url: `/projects/${projectId}/investigators/${investigatorId}/details` },
        { icon: FontAwesomeIcons.Duotone.RAMPLOADING, title: investigatorName ? investigatorName : "Investigator", url: `/projects/${projectId}/investigators/${investigatorId}/details` },
    ];

    return breadcrumbs;
};

export function ProjectInvestigatorsCreateBreadcrumbs(projectId: number, projectName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Projects", url: "/projects" },
        { icon: FontAwesomeIcons.Duotone.DICEONE, title: projectName ? projectName : "Project", url: `/projects/${projectId}/details` },
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Project Investigators", url: `/projects/${projectId}/investigators/create` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/projects/${projectId}/investigators/create` },
    ];

    return breadcrumbs;
};

export function ProjectDiscussionsBreadcrumbs(projectId: number, projectName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/projects" },
        { icon: FontAwesomeIcons.Duotone.DICED20, title: projectName ? projectName : "Project", url: `/projects/${projectId}/details` },
        { icon: FontAwesomeIcons.Duotone.COMMENTS, title: "Discussions", url: `/projects/${projectId}/discussions` },
    ];

    return breadcrumbs;
};

export function ProjectDiscussionDetailsBreadcrumbs(projectId: number, discussionId: number, projectName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/projects" },
        { icon: FontAwesomeIcons.Duotone.DICED20, title: projectName ? projectName : "Project", url: `/projects/${projectId}/details` },
        { icon: FontAwesomeIcons.Duotone.COMMENTS, title: "Discussions", url: `/projects/${projectId}/discussions` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/projects/${projectId}/discussions/${discussionId}/details` },
    ];

    return breadcrumbs;
};

export function ProjectDiscussionCreateBreadcrumbs(projectId: number, projectName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.CLIPBOARD, title: "Projects", url: "/projects" },
        { icon: FontAwesomeIcons.Duotone.DICED20, title: projectName ? projectName : "Project", url: `/projects/${projectId}/details` },
        { icon: FontAwesomeIcons.Duotone.COMMENTS, title: "Discussions", url: `/projects/${projectId}/discussions` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/projects/${projectId}/discussions/create` },
    ];

    return breadcrumbs;
};

export function InstitutionsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
    ];

    return breadcrumbs;
};

export function InstitutionBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
    ];

    return breadcrumbs;
};

export function InstitutionCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/institutions/create` },
    ];

    return breadcrumbs;
};

export function InstitutionCodesBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.SQUARECODE, title: "Codes", url: `/institutions/${institutionId}/codes` },
    ];

    return breadcrumbs;
};

export function InstitutionTrialsBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.TRIAL, title: "Trials", url: `/institutions/${institutionId}/trials` },
    ];

    return breadcrumbs;
};

export function InstitutionCodeBreadcrumbs(institutionId: number, institutionCodeId: number, institutionName?: string, institutionCodeName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.SQUARECODE, title: "Codes", url: `/institutions/${institutionId}/codes` },
        { icon: FontAwesomeIcons.Duotone.RECTANGLEBARCODE, title: institutionCodeName ? institutionCodeName : "Code", url: `/institutions/${institutionId}/codes/${institutionCodeId}/details` },
    ];

    return breadcrumbs;
};

export function InstitutionCreateCodeBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.SQUARECODE, title: "Codes", url: `/institutions/${institutionId}/codes` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/institutions/${institutionId}/codes/create` },
    ];

    return breadcrumbs;
};

export function InstitutionDepartmentsBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGMEMO, title: "Departments", url: `/institutions/${institutionId}/departments` },
    ];

    return breadcrumbs;
};

export function InstitutionDepartmentBreadcrumbs(institutionId: number, departmentId: number, institutionName?: string, departmentName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGMEMO, title: "Departments", url: `/institutions/${institutionId}/departments` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: departmentName ? departmentName : "Department", url: `/institutions/${institutionId}/departments/${departmentId}` },
    ];

    return breadcrumbs;
};

export function InstitutionCreateDepartmentBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGMEMO, title: "Departments", url: `/institutions/${institutionId}/departments` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/institutions/${institutionId}/departments/create` },
    ];

    return breadcrumbs;
};

export function InstitutionItemsBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.I, title: "Items", url: `/institutions/${institutionId}/institutionitems` },
    ];

    return breadcrumbs;
};

export function InstitutionLaboratoriesBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/institutions/${institutionId}/labs` },
    ];

    return breadcrumbs;
};


export function InstitutionLaboratoryBreadcrumbs(institutionId: number, institutionLaboratoryId: number, institutionName?: string, laboratoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/institutions/${institutionId}/labs` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Laboratory", url: `/institutions/${institutionId}/labs/${institutionLaboratoryId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/institutions/${institutionId}/labs/${institutionLaboratoryId}/details` },
    ];
    
    return breadcrumbs;
};

export function InstitutionLaboratoryCreateBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: `/institutions/${institutionId}/labs` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/institutions/${institutionId}/labs/create` },
    ];
    
    return breadcrumbs;
};
export function InstitutionProceduresBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.BOOK, title: "Procedures", url: `/institutions/${institutionId}/procedures` },
    ];

    return breadcrumbs;
};

export function InstitutionProcedureBreadcrumbs(institutionId: number, institutionProcedureId: number, institutionName?: string, procedureName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.BOOK, title: "Procedures", url: `/institutions/${institutionId}/procedures` },
        { icon: FontAwesomeIcons.Duotone.BOOKOPEN, title: procedureName ? procedureName : "Procedure", url: `/institutions/${institutionId}/procedures/${institutionProcedureId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/institutions/${institutionId}/procedures/${institutionProcedureId}/details` },
    ];

    return breadcrumbs;
};

export function InstitutionProcedureCreateBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.BOOK, title: "Procedures", url: `/institutions/${institutionId}/procedures` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/institutions/${institutionId}/procedures/create` },
    ];

    return breadcrumbs;
};

export function InstitutionFinanceBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN, title: "Finance", url: `/institutions/${institutionId}/finance` },
    ];

    return breadcrumbs;
};

export function InstitutionContractBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contract", url: `/institutions/${institutionId}/contract` },
    ];

    return breadcrumbs;
};

export function InstitutionDepartmentContactBreadcrumbs(institutionId: number, departmentId: number, contactId: number, institutionName?: string, departmentName?: string, contactName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGMEMO, title: "Departments", url: `/institutions/${institutionId}/departments` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: departmentName ? departmentName : "Department", url: `/institutions/${institutionId}/departments/${departmentId}` },
        { icon: FontAwesomeIcons.Duotone.ADDRESSBOOK, title: "Contacts", url: `/institutions/${institutionId}/departments/${departmentId}/contacts/${contactId}` },
        { icon: FontAwesomeIcons.Duotone.SIMCARDS, title: contactName ? contactName : "Contact", url: `/institutions/${institutionId}/departments/${departmentId}/contacts/${contactId}` },
    ];

    return breadcrumbs;
};

export function InstitutionCreateDepartmentContactBreadcrumbs(institutionId: number, departmentId: number, institutionName?: string, departmentName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGMEMO, title: "Departments", url: `/institutions/${institutionId}/departments` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: departmentName ? departmentName : "Department", url: `/institutions/${institutionId}/departments/${departmentId}` },
        { icon: FontAwesomeIcons.Duotone.ADDRESSBOOK, title: "Contacts", url: `/institutions/${institutionId}/departments/${departmentId}/contacts/create` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/institutions/${institutionId}/departments/${departmentId}/contacts/create` },
    ];

    return breadcrumbs;
};

export function InstitutionDepartmentPersonnelBreadcrumbs(institutionId: number, departmentId: number, personnelId: number, institutionName?: string, departmentName?: string, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGMEMO, title: "Departments", url: `/institutions/${institutionId}/departments` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: departmentName ? departmentName : "Department", url: `/institutions/${institutionId}/departments/${departmentId}` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/institutions/${institutionId}/departments/${departmentId}/personnel/${personnelId}` },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/institutions/${institutionId}/departments/${departmentId}/personnel/${personnelId}` },
    ];

    return breadcrumbs;
};

export function InstitutionCreateDepartmentPersonnelBreadcrumbs(institutionId: number, departmentId: number, institutionName?: string, departmentName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGMEMO, title: "Departments", url: `/institutions/${institutionId}/departments` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: departmentName ? departmentName : "Department", url: `/institutions/${institutionId}/departments/${departmentId}` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/institutions/${institutionId}/departments/${departmentId}/personnel/create` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/institutions/${institutionId}/departments/${departmentId}/personnel/create` },
    ];

    return breadcrumbs;
};

export function InstitutionPersonnelsBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/institutions/${institutionId}/personnel` },
    ];

    return breadcrumbs;
};

export function InstitutionPersonnelBreadcrumbs(institutionId: number, personnelId: number, institutionName?: string, personnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/institutions/${institutionId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: personnelName ? personnelName : "Personnel", url: `/institutions/${institutionId}/personnel/${personnelId}/details` },
    ];

    return breadcrumbs;
};

export function InstitutionCreatePersonnelBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/institutions/${institutionId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/institutions/${institutionId}/personnel/create` },
    ];

    return breadcrumbs;
};

export function InstitutionNotesBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: "Notes", url: `/institutions/${institutionId}/notes` },
    ];

    return breadcrumbs;
};

export function InstitutionNoteBreadcrumbs(institutionId: number, noteId: number, institutionName?: string, noteName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: "Notes", url: `/institutions/${institutionId}/notes` },
        { icon: FontAwesomeIcons.Duotone.NOTE, title: noteName ? noteName : "Note", url: `/institutions/${institutionId}/notes/${noteId}/details` },
    ];

    return breadcrumbs;
};

export function InstitutionNoteCreateBreadcrumbs(institutionId: number, institutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: "/institutions" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: institutionName ? institutionName : "Institution", url: `/institutions/${institutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.NOTESMEDICAL, title: "Notes", url: `/institutions/${institutionId}/notes` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/institutions/${institutionId}/notes/create` }
    ];

    return breadcrumbs;
};

export function LabsBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: "/labs" },
    ];

    return breadcrumbs;
};

export function LaboratoryDetailsBreadcrumbs(laboratoryId: number, laboratoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: "/labs" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/labs/${laboratoryId}/details` },
    ];

    return breadcrumbs;
};

export function LaboratoryCreateBreadcrumbs(): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: "/labs" },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/labs/create` },
    ];

    return breadcrumbs;
};

export function LaboratoryDepartmentsBreadcrumbs(laboratoryId: number, laboratoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: "/labs" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/labs/${laboratoryId}/details` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGMEMO, title: "Departments", url: `/labs/${laboratoryId}/departments` },
    ];

    return breadcrumbs;
};

export function LaboratoryDepartmentBreadcrumbs(laboratoryId: number, laboratoryDepartmentId: number, laboratoryName?: string, laboratoryDepartmentName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: "/labs" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/labs/${laboratoryId}/details` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGMEMO, title: "Departments", url: `/labs/${laboratoryId}/departments` },
        { icon: FontAwesomeIcons.Duotone.BUILDING, title: laboratoryDepartmentName ? laboratoryDepartmentName : "Department", url: `/labs/${laboratoryId}/departments/${laboratoryDepartmentId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/labs/${laboratoryId}/departments/${laboratoryDepartmentId}/details` },
    ];

    return breadcrumbs;
};

export function LaboratoryDepartmentCreateBreadcrumbs(laboratoryId: number, laboratoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: "/labs" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/labs/${laboratoryId}/details` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGMEMO, title: "Departments", url: `/labs/${laboratoryId}/departments` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/labs/${laboratoryId}/departments/create` },
    ];

    return breadcrumbs;
};

export function LaboratoryPersonnelsBreadcrumbs(laboratoryId: number, laboratoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: "/labs" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/labs/${laboratoryId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/labs/${laboratoryId}/personnel` },
    ];

    return breadcrumbs;
};

export function LaboratoryPersonnelBreadcrumbs(laboratoryId: number, laboratoryPersonnelId: number, laboratoryName?: string, laboratoryPersonnelName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: "/labs" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/labs/${laboratoryId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/labs/${laboratoryId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.IDBADGE, title: laboratoryPersonnelName ? laboratoryPersonnelName : "Person", url: `/labs/${laboratoryId}/personnel/${laboratoryPersonnelId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/labs/${laboratoryId}/personnel/${laboratoryPersonnelId}/details` },
    ];

    return breadcrumbs;
};

export function LaboratoryPersonnelCreateBreadcrumbs(laboratoryId: number, laboratoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: "/labs" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/labs/${laboratoryId}/details` },
        { icon: FontAwesomeIcons.Duotone.USER, title: "Personnel", url: `/labs/${laboratoryId}/personnel` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/labs/${laboratoryId}/personnel/create` },
    ];

    return breadcrumbs;
};

export function LaboratoryInstitutionsBreadcrumbs(laboratoryId: number, laboratoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: "/labs" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/labs/${laboratoryId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/labs/${laboratoryId}/institutions` },
    ];

    return breadcrumbs;
};

export function LaboratoryInstitutionBreadcrumbs(laboratoryId: number, laboratoryInstitutionId: number, laboratoryName?: string, laboratoryInstitutionName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: "/labs" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/labs/${laboratoryId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/labs/${laboratoryId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.BUILDINGS, title: laboratoryInstitutionName ? laboratoryInstitutionName : "Institution", url: `/labs/${laboratoryId}/institutions/${laboratoryInstitutionId}/details` },
        { icon: FontAwesomeIcons.Duotone.CIRCLEINFO, title: "Details", url: `/labs/${laboratoryId}/institutions/${laboratoryInstitutionId}/details` },
    ];

    return breadcrumbs;
};

export function LaboratoryInstitutionCreateBreadcrumbs(laboratoryId: number, laboratoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: "/labs" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/labs/${laboratoryId}/details` },
        { icon: FontAwesomeIcons.Duotone.INSTITUTION, title: "Institutions", url: `/labs/${laboratoryId}/institutions` },
        { icon: FontAwesomeIcons.Duotone.SQUAREPLUS, title: "Create", url: `/labs/${laboratoryId}/institutions/create` },
    ];

    return breadcrumbs;
};

export function LaboratoryFinanceBreadcrumbs(laboratoryId: number, laboratoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: "/labs" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/labs/${laboratoryId}/details` },
        { icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN, title: "Finance", url: `/labs/${laboratoryId}/finance` },
    ];

    return breadcrumbs;
};

export function LaboratoryContractBreadcrumbs(laboratoryId: number, laboratoryName?: string): INavItem[] {
    let breadcrumbs: INavItem[] = [
        { icon: FontAwesomeIcons.Duotone.FLASKVIAL, title: "Labs", url: "/labs" },
        { icon: FontAwesomeIcons.Duotone.BUILDINGWHEAT, title: laboratoryName ? laboratoryName : "Lab", url: `/labs/${laboratoryId}/details` },
        { icon: FontAwesomeIcons.Duotone.FILECONTRACT, title: "Contract", url: `/labs/${laboratoryId}/contract` },
    ];

    return breadcrumbs;
};